/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerUpdateRequestBranding
 */
export interface CustomerUpdateRequestBranding {
    /**
     * The lottery's logo image URL. Null clears it.
     * @type {string}
     * @memberof CustomerUpdateRequestBranding
     */
    logoUrl?: string | null;
}

/**
 * Check if a given object implements the CustomerUpdateRequestBranding interface.
 */
export function instanceOfCustomerUpdateRequestBranding(value: object): value is CustomerUpdateRequestBranding {
    return true;
}

export function CustomerUpdateRequestBrandingFromJSON(json: any): CustomerUpdateRequestBranding {
    return CustomerUpdateRequestBrandingFromJSONTyped(json, false);
}

export function CustomerUpdateRequestBrandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerUpdateRequestBranding {
    if (json == null) {
        return json;
    }
    return {
        
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
    };
}

export function CustomerUpdateRequestBrandingToJSON(value?: CustomerUpdateRequestBranding | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'logoUrl': value['logoUrl'],
    };
}

